// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Mobile / PWA base ─────────────────────────────────────────── */
:root {
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --bottom-nav-h: 64px;
}
html, body { overscroll-behavior-y: none; }
.table-mobile-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
.bottom-nav-safe {
  padding-bottom: calc(var(--safe-bottom) + 8px);
  height: calc(var(--bottom-nav-h) + var(--safe-bottom));
}
.mobile-content-pad { padding-bottom: calc(var(--bottom-nav-h) + var(--safe-bottom) + 16px); }
@media screen and (max-width: 768px) {
  input[type="text"], input[type="email"], input[type="number"],
  input[type="password"], input[type="date"], input[type="time"],
  select, textarea { font-size: 16px !important; }
}
/* ── Existing ─────────────────────────── */
.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #0f0f10;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,oBAAoB;AACtB;AACA,aAAa,2BAA2B,EAAE;AAC1C,uBAAuB,gBAAgB,EAAE,iCAAiC,EAAE;AAC5E;EACE,8CAA8C;EAC9C,sDAAsD;AACxD;AACA,sBAAsB,qEAAqE,EAAE;AAC7F;EACE;;qBAEmB,0BAA0B,EAAE;AACjD;AACA,4CAA4C;AAC5C;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* ── Mobile / PWA base ─────────────────────────────────────────── */\n:root {\n  --safe-top: env(safe-area-inset-top, 0px);\n  --safe-bottom: env(safe-area-inset-bottom, 0px);\n  --bottom-nav-h: 64px;\n}\nhtml, body { overscroll-behavior-y: none; }\n.table-mobile-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }\n.bottom-nav-safe {\n  padding-bottom: calc(var(--safe-bottom) + 8px);\n  height: calc(var(--bottom-nav-h) + var(--safe-bottom));\n}\n.mobile-content-pad { padding-bottom: calc(var(--bottom-nav-h) + var(--safe-bottom) + 16px); }\n@media screen and (max-width: 768px) {\n  input[type=\"text\"], input[type=\"email\"], input[type=\"number\"],\n  input[type=\"password\"], input[type=\"date\"], input[type=\"time\"],\n  select, textarea { font-size: 16px !important; }\n}\n/* ── Existing ─────────────────────────── */\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #0f0f10;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
